import request from '@/utils/ai-train-request'

// AI训战 - 分类树（ai_scene_category：公司军校/部门军校/皮科研修院三块，level 1-3）
// 任务书 §3.2 只写了"分类树 CRUD"，没给具体路径，这里按表名自定，
// 与后端 agent 联调时如有出入以后端实际实现为准（见实现记录）。
const apiPath = '/admin/scene-category'

const aiTrainCategoryApi = {
  /**
   * 分类树（按 schoolType 过滤，不传则返回三块全部）
   */
  fetchTree(schoolType) {
    return request({
      url: `${apiPath}/tree`,
      method: 'get',
      params: schoolType ? { schoolType } : {}
    })
  },
  create(data) {
    return request({ url: apiPath, method: 'post', data })
  },
  update(data) {
    return request({ url: apiPath, method: 'put', data })
  },
  deleteById(id) {
    return request({ url: `${apiPath}/${id}`, method: 'delete' })
  },
  /**
   * 拖拽/上移下移排序
   */
  sort(data) {
    return request({ url: `${apiPath}/sort`, method: 'put', data })
  },
  setState(id, state) {
    return request({ url: `${apiPath}/${id}/state`, method: 'put', data: { state } })
  }
}

export default aiTrainCategoryApi
